import React, { useLayoutEffect, useRef } from 'react';


import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_continentsLow from "@amcharts/amcharts4-geodata/continentsLow";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { ICountryRankingType } from '../../actions/StatsActions';

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export interface IGlobeMapChartProps {
    id: string;
    title: string;
    data: Array<ICountryRankingType>;
  }

const GlobeMap : React.FC<IGlobeMapChartProps> = (props: IGlobeMapChartProps) => {
    useLayoutEffect(() => {
        // Create map instance
    let chart = am4core.create(props.id, am4maps.MapChart);
    let colorSet = new am4core.ColorSet();

    let data: any = {};
    for (let i = 0; i < props.data.length; i++) {
        let item: ICountryRankingType = props.data[i];
        data[`${item.countryIsoCode}`] = item.count;
    }

    try {
        chart.geodata = am4geodata_worldLow;
    }
    catch (e) {
        chart.raiseCriticalError(new Error("Map geodata could not be loaded. Please download the latest <a href=\"https://www.amcharts.com/download/download-v4/\">amcharts geodata</a> and extract its contents into the same directory as your amCharts files."));
    }

    //let labelColor = colorSet.getIndex(17);
    let perfectColor = am4core.color("#6601B5");
    let greatColor = am4core.color("#016AC1");
    let goodColor = am4core.color("#05A085");
    let hitColor = am4core.color("#BFFFA1");
    let whiteColor = am4core.color("#FFFFFF");
    let grayColor = am4core.color("#414B55");
    let waterColor = am4core.color("#111111");
    let countryColor = perfectColor;
    let countryOutline = am4core.color("#4C0189");
    let hoverColor = am4core.color("#8F27E5");
    let hoverTextColor = hitColor;
    let dotsColor = hitColor;
    let dotsHoverColor = hitColor;

    let label = chart.createChild(am4core.Label)
    label.text = props.title// "12 months (3/7/2019 data) rolling measles\nincidence per 1'000'000 total population. \n Bullet size uses logarithmic scale.";
    label.fontSize = 12;
    label.align = "left";
    label.valign = "top"
    label.fill = perfectColor;// am4core.color("#927459");
    label.background = new am4core.RoundedRectangle();
    (label.background as any).cornerRadius(10,10,10,10);
    label.padding(10,10,10,10);
    label.marginLeft = 30;
    label.marginBottom = 30;
    label.background.strokeOpacity = 0.3;
    label.background.stroke = whiteColor;// am4core.color("#927459");
    //label.background.fill = am4core.color("#f9e3ce");
    label.background.fillOpacity = 0.6;

    let dataSource = chart.createChild(am4core.TextLink)
    dataSource.text = "This visualization includes GeoLite2 data created by MaxMind,\navailable from https://www.maxmind.com."// "Data source: WHO";
    dataSource.fontSize = 8;
    dataSource.align = "right";
    dataSource.valign = "bottom"
    dataSource.url = "https://www.maxmind.com";// "https://www.who.int/immunization/monitoring_surveillance/burden/vpd/surveillance_type/active/measles_monthlydata/en/"
    dataSource.urlTarget = "_blank";
    dataSource.fill = grayColor;// am4core.color("#927459");
    dataSource.padding(10,10,10,10);
    dataSource.marginLeft = 30;
    dataSource.marginTop = 30;

    // Set projection
    chart.projection = new am4maps.projections.Orthographic();
    chart.panBehavior = "rotateLongLat";
    chart.padding(20,20,20,20);

    // Add zoom control
    chart.zoomControl = new am4maps.ZoomControl();

    let homeButton = new am4core.Button();
    homeButton.events.on("hit", function(){
        chart.goHome();
    });

    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
    homeButton.marginBottom = 10;
    homeButton.parent = chart.zoomControl;
    homeButton.insertBefore(chart.zoomControl.plusButton);

    // Water
    chart.backgroundSeries.mapPolygons.template.polygon.fill = waterColor;// colorSet.getIndex(0);// am4core.color("#bfa58d");
    chart.backgroundSeries.mapPolygons.template.polygon.fillOpacity = 1;
    chart.deltaLongitude = 20;
    chart.deltaLatitude = -20;

    // limits vertical rotation
    chart.adapter.add("deltaLatitude", function(delatLatitude: any){
        return am4core.math.fitToRange(delatLatitude, -90, 90);
    })

    // Create map polygon series

    // let shadowPolygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    // shadowPolygonSeries.geodata = am4geodata_continentsLow;

    // try {
    //     shadowPolygonSeries.geodata = am4geodata_continentsLow;
    // }
    // catch (e) {
    //     shadowPolygonSeries.raiseCriticalError(new Error("Map geodata could not be loaded. Please download the latest <a href=\"https://www.amcharts.com/download/download-v4/\">amcharts geodata</a> and extract its contents into the same directory as your amCharts files."));
    // }

    // shadowPolygonSeries.useGeodata = true;
    // shadowPolygonSeries.dx = 2;
    // shadowPolygonSeries.dy = 2;
    // shadowPolygonSeries.mapPolygons.template.fill = hitColor;//am4core.color("#000");
    // shadowPolygonSeries.mapPolygons.template.fillOpacity = 0.2;
    // shadowPolygonSeries.mapPolygons.template.strokeOpacity = 0;
    // shadowPolygonSeries.fillOpacity = 0.1;
    // shadowPolygonSeries.fill = hitColor;//am4core.color("#000");

    // Create map polygon series
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.useGeodata = true;

    polygonSeries.calculateVisualCenter = true;
    (polygonSeries.tooltip as any).background.fillOpacity = 0.2;
    (polygonSeries.tooltip as any).background.cornerRadius = 20;

    // Countries
    let template = polygonSeries.mapPolygons.template;
    template.nonScalingStroke = true;
    template.fill = countryColor; // am4core.color("#f9e3ce");
    template.stroke = countryOutline; //colorSet.getIndex(4);// am4core.color("#e2c9b0");

    polygonSeries.calculateVisualCenter = true;
    template.propertyFields.id = "id";
    template.tooltipPosition = "fixed";
    template.fillOpacity = 1;

    template.events.on("over", function (event) {
    if (event.target.dummyData) {
        event.target.dummyData.isHover = true;
    }
    })
    template.events.on("out", function (event) {
    if (event.target.dummyData) {
        event.target.dummyData.isHover = false;
    }
    })

    // Hover
    let hs = polygonSeries.mapPolygons.template.states.create("hover");
    hs.properties.fillOpacity = 1;
    hs.properties.fill = hoverColor;// colorSet.getIndex(5);// am4core.color("#deb7ad");


    let graticuleSeries = chart.series.push(new am4maps.GraticuleSeries());
    graticuleSeries.mapLines.template.stroke = hitColor;//colorSet.getIndex(9);// am4core.color("#fff");
    graticuleSeries.fitExtent = false;
    graticuleSeries.mapLines.template.strokeOpacity = 0.2;
    graticuleSeries.mapLines.template.stroke = hitColor;// colorSet.getIndex(8);// am4core.color("#fff");

    // Hover text
    let measelsSeries = chart.series.push(new am4maps.MapPolygonSeries()) as any
    measelsSeries.tooltip.background.fillOpacity = 0;
    measelsSeries.tooltip.background.cornerRadius = 20;
    measelsSeries.tooltip.autoTextColor = false;
    measelsSeries.tooltip.label.fill = hoverTextColor;// colorSet.getIndex(3);// am4core.color("#000");
    measelsSeries.tooltip.dy = -5;

    // Dots
    let measelTemplate = measelsSeries.mapPolygons.template;
    measelTemplate.fill = dotsColor;// colorSet.getIndex(7);// am4core.color("#bf7569");
    measelTemplate.strokeOpacity = 0;
    measelTemplate.fillOpacity = 0.75;
    measelTemplate.tooltipPosition = "fixed";

    // Dots hover
    let hs2 = measelsSeries.mapPolygons.template.states.create("hover");
    hs2.properties.fillOpacity = 1;
    hs2.properties.fill = dotsHoverColor;// colorSet.getIndex(6);// am4core.color("#86240c");

    polygonSeries.events.on("inited", function () {
    polygonSeries.mapPolygons.each(function (mapPolygon) {
        let count: number = (data as any)[mapPolygon.id];

        if (count > 0) {
        let polygon = measelsSeries.mapPolygons.create();
        polygon.multiPolygon = am4maps.getCircle(mapPolygon.visualLongitude, mapPolygon.visualLatitude, Math.max(0.2, Math.log(count) * Math.LN10 / 10));
        polygon.tooltipText = (mapPolygon.dataItem.dataContext as any).name + ": " + count.toLocaleString('en-US');
        mapPolygon.dummyData = polygon;
        polygon.events.on("over", function () {
            mapPolygon.isHover = true;
        })
        polygon.events.on("out", function () {
            mapPolygon.isHover = false;
        })
        }
        else {
        mapPolygon.tooltipText = (mapPolygon.dataItem.dataContext as any).name + ": no data";
        mapPolygon.fillOpacity = 0.9;
        }

    })
    })
    
        return () => {
          chart.dispose();
        };
      }, [props]);
    
    return (
        <div className="GlobalMap" id={props.id} style={{ width: "100%", height: "500px" }}></div>
    );
  }
  
  export default GlobeMap;